const LESSON_DATA = ['name', 'logo', 'display_order', 'description'];

export const getLessonData = data => {
  return Object.keys(data).reduce((acc, key) => {
    if (!LESSON_DATA.includes(key)) return acc;
    acc[key] = key === 'display_order' ? +data[key] : data[key];
    return acc;
  }, {});
};
